/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AgentRecordDto,
  ApiErrorResponse,
  CreateAgentRequest,
  OkResponse2,
  PatchAgentRequest
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getPostApiAgentsUrl = () => {




  return `/api/agents`
}

export const postApiAgents = async (createAgentRequest: CreateAgentRequest, options?: RequestInit): Promise<AgentRecordDto> => {

  return orvalControlFetch<AgentRecordDto>(getPostApiAgentsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAgentRequest,)
  }
);}




export const getPostApiAgentsMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAgents>>, TError,{data: CreateAgentRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAgents>>, TError,{data: CreateAgentRequest}, TContext> => {

const mutationKey = ['postApiAgents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAgents>>, {data: CreateAgentRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiAgents(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAgentsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAgents>>>
    export type PostApiAgentsMutationBody = CreateAgentRequest
    export type PostApiAgentsMutationError = ApiErrorResponse

    export const usePostApiAgents = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAgents>>, TError,{data: CreateAgentRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAgents>>,
        TError,
        {data: CreateAgentRequest},
        TContext
      > => {
      return useMutation(getPostApiAgentsMutationOptions(options), queryClient);
    }
    export const getGetApiAgentsUrl = () => {




  return `/api/agents`
}

export const getApiAgents = async ( options?: RequestInit): Promise<AgentRecordDto[]> => {

  return orvalControlFetch<AgentRecordDto[]>(getGetApiAgentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiAgentsQueryKey = () => {
    return [
    `/api/agents`
    ] as const;
    }


export const getGetApiAgentsQueryOptions = <TData = Awaited<ReturnType<typeof getApiAgents>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgents>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAgentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAgents>>> = ({ signal }) => getApiAgents({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAgents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAgentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAgents>>>
export type GetApiAgentsQueryError = unknown


export function useGetApiAgents<TData = Awaited<ReturnType<typeof getApiAgents>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAgents>>,
          TError,
          Awaited<ReturnType<typeof getApiAgents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAgents<TData = Awaited<ReturnType<typeof getApiAgents>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAgents>>,
          TError,
          Awaited<ReturnType<typeof getApiAgents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAgents<TData = Awaited<ReturnType<typeof getApiAgents>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgents>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAgents<TData = Awaited<ReturnType<typeof getApiAgents>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgents>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAgentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiAgentsAgentIdUrl = (agentId: string,) => {




  return `/api/agents/${agentId}`
}

export const getApiAgentsAgentId = async (agentId: string, options?: RequestInit): Promise<AgentRecordDto> => {

  return orvalControlFetch<AgentRecordDto>(getGetApiAgentsAgentIdUrl(agentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiAgentsAgentIdQueryKey = (agentId: string,) => {
    return [
    `/api/agents/${agentId}`
    ] as const;
    }


export const getGetApiAgentsAgentIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiAgentsAgentId>>, TError = ApiErrorResponse>(agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAgentsAgentIdQueryKey(agentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAgentsAgentId>>> = ({ signal }) => getApiAgentsAgentId(agentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(agentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAgentsAgentIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAgentsAgentId>>>
export type GetApiAgentsAgentIdQueryError = ApiErrorResponse


export function useGetApiAgentsAgentId<TData = Awaited<ReturnType<typeof getApiAgentsAgentId>>, TError = ApiErrorResponse>(
 agentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAgentsAgentId>>,
          TError,
          Awaited<ReturnType<typeof getApiAgentsAgentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAgentsAgentId<TData = Awaited<ReturnType<typeof getApiAgentsAgentId>>, TError = ApiErrorResponse>(
 agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAgentsAgentId>>,
          TError,
          Awaited<ReturnType<typeof getApiAgentsAgentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAgentsAgentId<TData = Awaited<ReturnType<typeof getApiAgentsAgentId>>, TError = ApiErrorResponse>(
 agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAgentsAgentId<TData = Awaited<ReturnType<typeof getApiAgentsAgentId>>, TError = ApiErrorResponse>(
 agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAgentsAgentIdQueryOptions(agentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPatchApiAgentsAgentIdUrl = (agentId: string,) => {




  return `/api/agents/${agentId}`
}

export const patchApiAgentsAgentId = async (agentId: string,
    patchAgentRequest: PatchAgentRequest, options?: RequestInit): Promise<AgentRecordDto> => {

  return orvalControlFetch<AgentRecordDto>(getPatchApiAgentsAgentIdUrl(agentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchAgentRequest,)
  }
);}




export const getPatchApiAgentsAgentIdMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiAgentsAgentId>>, TError,{agentId: string;data: PatchAgentRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchApiAgentsAgentId>>, TError,{agentId: string;data: PatchAgentRequest}, TContext> => {

const mutationKey = ['patchApiAgentsAgentId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiAgentsAgentId>>, {agentId: string;data: PatchAgentRequest}> = (props) => {
          const {agentId,data} = props ?? {};

          return  patchApiAgentsAgentId(agentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiAgentsAgentIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiAgentsAgentId>>>
    export type PatchApiAgentsAgentIdMutationBody = PatchAgentRequest
    export type PatchApiAgentsAgentIdMutationError = ApiErrorResponse

    export const usePatchApiAgentsAgentId = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiAgentsAgentId>>, TError,{agentId: string;data: PatchAgentRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiAgentsAgentId>>,
        TError,
        {agentId: string;data: PatchAgentRequest},
        TContext
      > => {
      return useMutation(getPatchApiAgentsAgentIdMutationOptions(options), queryClient);
    }
    export const getDeleteApiAgentsAgentIdUrl = (agentId: string,) => {




  return `/api/agents/${agentId}`
}

export const deleteApiAgentsAgentId = async (agentId: string, options?: RequestInit): Promise<OkResponse2> => {

  return orvalControlFetch<OkResponse2>(getDeleteApiAgentsAgentIdUrl(agentId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiAgentsAgentIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAgentsAgentId>>, TError,{agentId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiAgentsAgentId>>, TError,{agentId: string}, TContext> => {

const mutationKey = ['deleteApiAgentsAgentId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiAgentsAgentId>>, {agentId: string}> = (props) => {
          const {agentId} = props ?? {};

          return  deleteApiAgentsAgentId(agentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiAgentsAgentIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiAgentsAgentId>>>

    export type DeleteApiAgentsAgentIdMutationError = unknown

    export const useDeleteApiAgentsAgentId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAgentsAgentId>>, TError,{agentId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiAgentsAgentId>>,
        TError,
        {agentId: string},
        TContext
      > => {
      return useMutation(getDeleteApiAgentsAgentIdMutationOptions(options), queryClient);
    }
